<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from 'vue-good-table';
const dropdownsApi = ClientFactory.get("dropdowns");
const RankingsReportApi = ClientFactory.get("rankingsReport");

export default {
   components: {
      VueGoodTable
  },
  data() {
    return {
      department_id: 0,
      year: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      data: [],
      years: [],
      departments:[]
    };
  },
  async created() {
    // this.department_id= this.AppActiveUser.department_id;
    this.years = await dropdownsApi.get(dropdownsApi.type.YEARS);
    this.departments = await dropdownsApi.get(dropdownsApi.type.DEPARTMENTS);

    this.getRankingsReport();
  },
  methods: {
    ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    rowStyleClassFn(row) {
      return row.is_title > 0 ? 'header-row' : '';
    },
    getRankingsReport: async function () {
      this.loading(this.$vs);
      const { data: response } = await RankingsReportApi.getRankingsReport(this.year, this.currentMonth, this.department_id);
      this.closeLoading();
      if(response?.status != "success") {
        return this.notify({
          error:true,
          title: "Thông báo",
          text: response?.message || "Đã có lỗi"
        });
      }
      this.data = response?.data || [];
    },
    downloadReport: async function() {
      this.loading(this.$vs);
      // send request
      const response = await RankingsReportApi.downloadRankingsReport(this.year, this.currentMonth, this.department_id);
      this.closeLoading();
      if(typeof response === 'undefined' || response.status === 'failed') {
          return this.notify({
              error: true,
              text: response.message || "Unknow error",
          });
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tong_hop_xep_loai_loai_dong_${this.currentMonth}_${this.year}.xlsx`)
      link.click();
      window.URL.revokeObjectURL(url);
    }
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    months() {
      return [
        {
          value: 1,
          label: "Tháng 1",
        },
        {
          value: 2,
          label: "Tháng 2",
        },
        {
          value: 3,
          label: "Tháng 3",
        },
        {
          value: 4,
          label: "Tháng 4",
        },
        {
          value: 5,
          label: "Tháng 5",
        },
        {
          value: 6,
          label: "Tháng 6",
        },
        {
          value: 7,
          label: "Tháng 7",
        },
        {
          value: 8,
          label: "Tháng 8",
        },
        {
          value: 9,
          label: "Tháng 9",
        },
        {
          value: 10,
          label: "Tháng 10",
        },
        {
          value: 11,
          label: "Tháng 11",
        },
        {
          value: 12,
          label: "Tháng 12",
        },
      ]
    },
    columns() {
      return [
        {
          label: 'Họ và Tên',
          field: 'full_name',
          thClass: 'emu-vgt-thead-th text-center',
          tdClass: 'emu-vgt-tbody-td',
        },
        {
          label: 'Phòng ban',
          field: 'department_name',
          thClass: 'emu-vgt-thead-th text-center ',
          tdClass: 'emu-vgt-tbody-td',
        },
        {
          label: 'Số ngày công',
          field: 'total_timekeeping',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
          width: "200px",
        },
        {
          label: 'Điểm thi đua',
          field: 'total_point',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
          width: "200px",
        },
        {
          label: 'Xếp loại lao động',
          field: 'graded',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
          width: "200px",
        },
      ]
    },
  },
  destroyed() {
    this.closeLoading();
  }
}
</script>
<template>
  <div class="rankings_report">
    <CCard title="Tổng hợp xếp loại lao động" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
           <span class="card-header-title">Tổng hợp xếp loại lao động</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow class="mt-2 center">
            <CCol sm="2">
              <label class='mb-0'>Năm</label>
              <CSelect
                :options=years
                :value.sync="year"
                class=" pt-1"
                @change="getRankingsReport"
              />
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>Tháng</label>
              <CSelect
                :options=months
                :value.sync="currentMonth"
                class="pt-1"
                @change="getRankingsReport"
              />
            </CCol>
            <CCol sm="3">
              <label class='mb-0'>Phòng ban</label>
              <CSelect
                :options=departments
                :value.sync="department_id"
                class="pt-1"
                @change="getRankingsReport"
              />
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="12" class="center">
              <vs-button warn square class="custom_btn_search" @click="getRankingsReport()"><i class='bx bx-search'></i>Tra cứu</vs-button>
            </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <vue-good-table
          :columns="columns"
          :rows="data"
          compactMode
          :sort-options="{
            enabled:false
          }"
          :pagination-options="{
              enabled: true,
              perPage: 100,
              perPageDropdownEnabled: false,
              nextLabel: 'Trang sau',
              prevLabel: 'Trang trước',
              ofLabel: 'của',
          }"
          :line-numbers="true"
          :row-style-class="rowStyleClassFn"
        >
          <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
            Không có dữ liệu
          </div>
          <!-- <template
            slot="table-row"
            slot-scope="props"
          >
          </template> -->
        </vue-good-table>
        <CRow>
          <CCol sm="12" class="" style="margin-top:10px">
            <vs-button
              success
              square
              :disabled="this.data.length===0"
              @click="downloadReport()"
            >
              <i class="bx bxs-download"></i>&nbsp;Tải về</vs-button
            >
          </CCol>
      </CRow>
    </CCard>
  </div>
</template>

<style lang="scss">
  .rankings_report{
    table.vgt-table td {
      vertical-align: inherit;
      padding: 0em .75em .0em .75em;
    }
    .vgt-responsive {
        overflow-x: inherit;
    }
    .width-class{
      min-width: 3px !important;
    }
    .width-status{
      min-width: 10px !important;
    }
  }
</style>